import { type ErrorHandler, Injectable, inject } from '@angular/core';
import { SawDust } from '@cudirect/shared-ui-library';

// The `GlobalErrorHandler` service is automatically registered with Angular's
// dependency injection system and will catch all uncaught errors in our
// application. It uses the SawDust logger to log these errors.
@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  public logger = inject(SawDust);

  constructor() {
    this.logger = this.logger.withContext({ handler: 'GlobalErrorHandler' });
  }

  handleError(error: Error): void {
    this.logger.errorOnly(error);
  }
}
